import React from "react";
import accessoriesImage from "accessories.png"; // Import the image
import "../../AnimatedAccessories.css"; // Import the CSS for the animation

const AnimatedAccessories: React.FC = () => {
    return (
        <div className="accessories-container">
            <img
                className="animated-accessories"
                id="accessories-loop-animation"
                src={accessoriesImage}
                alt="error loading page. please refresh!"
            />
        </div>
    );
};

export default AnimatedAccessories;
